import styled from 'styled-components';
import { styledDescriptions } from '../styled/mixin';
import {
  Invoice,
  InvoiceApprovalType,
  InvoiceStatus,
  invoiceStatusKorean,
} from '../../modules/invoices';
import {
  Alert,
  Button,
  Col,
  Descriptions,
  Row,
  Space,
  Tag,
  Tooltip,
} from 'antd';
import Title from 'antd/lib/typography/Title';
import {
  corporateNumberFormatter,
  maskingRrn,
  phoneFormatter,
  priceToString,
} from '../../util/utils';
import InvoiceHistoriesComponent from './InvoiceHistoriesComponent';
import SubInvoiceListComponent from './SubInvoiceListComponent';
import {
  VendorType,
  VendorWorkerWageForm,
  vendorWorkerWageFormKorean,
} from '../../modules/vendors';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { USER_ROLE_NAME, User } from '../../modules/auth';
import InvoicePaymentListComponent from './InvoicePaymentListComponent';
import { useEffect, useState } from 'react';
import Link from 'antd/lib/typography/Link';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface InvoiceDetailComponentProps {
  invoice: Invoice;
  user: User;
  isEnterpriseLevel: boolean;
  moveToEditPage?: () => void;
  onOpenCreateInvoiceCommentModal: () => void;
  onOpenCreateInvoicePaymentModal: () => void;
  openSubInvoiceDetailDrawer?: (invoiceId: string) => void;
  openSubInvoiceCreateModal?: () => void;
  excludeSubInvoice?: (invoiceId: string) => void;
  updateInvoiceStatus: (approvalType: InvoiceApprovalType) => void;
  openPdfFile: (file: any) => void;
}

function InvoiceDetailComponent({
  invoice,
  user,
  isEnterpriseLevel,
  moveToEditPage,
  onOpenCreateInvoiceCommentModal,
  onOpenCreateInvoicePaymentModal,
  openSubInvoiceDetailDrawer,
  openSubInvoiceCreateModal,
  excludeSubInvoice,
  updateInvoiceStatus,
  openPdfFile,
}: InvoiceDetailComponentProps) {
  useEffect(() => {
    const fileList = invoice.file.map((file: any) => (
      <li key={file.id}>
        <Link
          onClick={(e) => {
            e.stopPropagation();
            openPdfFile(file);
          }}
        >
          {file.name}
        </Link>
      </li>
    ));
    setPdfFileList(fileList);
  }, [invoice.file, openPdfFile]);

  const [pdfFileList, setPdfFileList] = useState<any[]>([]);

  return (
    <StyledDiv>
      <Row justify="space-between" align="bottom">
        <Col>
          <Title level={3}>
            청구서 상세 ({invoiceStatusKorean[invoice.status]})
          </Title>
        </Col>
      </Row>
      {/* {isEnterpriseLevel && (
        <Row>
          <Col span={24}>
            {invoice.status === InvoiceStatus.APPROVING && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceStatus.APPROVED)
                      }
                    >
                      승인
                    </Button>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceStatus.DECLINED)
                      }
                    >
                      반려
                    </Button>
                  </Space>
                }
              />
            )}
            {invoice.status === InvoiceStatus.APPROVED && (
              <Alert
                message={`청구금액 지급 여부를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceStatus.PAYMENT_COMPLETED)
                      }
                    >
                      지급완료
                    </Button>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceStatus.DECLINED)
                      }
                    >
                      반려
                    </Button>
                  </Space>
                }
              />
            )}
          </Col>
        </Row>
      )} */}

      <Row>
        <Col span={24}>
          {invoice.status === InvoiceStatus.DRAFT &&
            invoice.submittedBy.id === user.id && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(
                          InvoiceApprovalType.REQUEST_APPROVAL,
                        )
                      }
                    >
                      승인요청하기
                    </Button>
                  </Space>
                }
              />
            )}

          {invoice.status === InvoiceStatus.APPROVED &&
            user.roleName === USER_ROLE_NAME.ADMIN && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() => onOpenCreateInvoicePaymentModal()}
                    >
                      지급금 입력하기
                    </Button>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceApprovalType.CANCEL_APPROVAL)
                      }
                    >
                      승인취소하기
                    </Button>
                  </Space>
                }
              />
            )}

          {invoice.status === InvoiceStatus.PAYMENT_COMPLETED &&
            user.roleName === USER_ROLE_NAME.ADMIN && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() => onOpenCreateInvoicePaymentModal()}
                    >
                      지급금 수정하기
                    </Button>
                  </Space>
                }
              />
            )}

          {invoice.status === InvoiceStatus.DECLINED &&
            invoice.submittedBy.id === user.id && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(
                          InvoiceApprovalType.REQUEST_APPROVAL,
                        )
                      }
                    >
                      승인요청하기
                    </Button>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceApprovalType.RECALL_APPROVAL)
                      }
                    >
                      회수하기
                    </Button>
                  </Space>
                }
              />
            )}

          {invoice.status === InvoiceStatus.APPROVING &&
            invoice.approver.id === user.id && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(
                          InvoiceApprovalType.REQUEST_APPROVAL,
                        )
                      }
                    >
                      승인하기
                    </Button>
                    {invoice.submittedBy.id !== user.id && (
                      <Button
                        size="small"
                        type="ghost"
                        onClick={() =>
                          updateInvoiceStatus(
                            InvoiceApprovalType.DECLINE_APPROVAL,
                          )
                        }
                      >
                        반려하기
                      </Button>
                    )}
                    {invoice.submittedBy.id === user.id && (
                      <Button
                        size="small"
                        type="ghost"
                        onClick={() =>
                          updateInvoiceStatus(
                            InvoiceApprovalType.RECALL_APPROVAL,
                          )
                        }
                      >
                        회수하기
                      </Button>
                    )}
                  </Space>
                }
              />
            )}

          {invoice.status === InvoiceStatus.APPROVING &&
            invoice.approver.id !== user.id &&
            invoice.submittedBy.id === user.id && (
              <Alert
                message={`청구서 검토 결과를 선택하세요.`}
                type="warning"
                action={
                  <Space>
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceApprovalType.RECALL_APPROVAL)
                      }
                    >
                      회수하기
                    </Button>
                  </Space>
                }
              />
            )}

          {/* {invoice.status === InvoiceStatus.APPROVING && (
            <Alert
              message={`청구서 검토 결과를 선택하세요.`}
              type="warning"
              action={
                <Space>
                  {invoice.approver.id === user.id && (
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(
                          InvoiceApprovalType.REQUEST_APPROVAL,
                        )
                      }
                    >
                      승인하기
                    </Button>
                  )}
                  {invoice.approver.id === user.id &&
                    invoice.submittedBy.id !== user.id && (
                      <>
                        <Button
                          size="small"
                          type="ghost"
                          onClick={() =>
                            updateInvoiceStatus(
                              InvoiceApprovalType.DECLINE_APPROVAL,
                            )
                          }
                        >
                          반려하기
                        </Button>
                      </>
                    )}
                  {invoice.submittedBy.id === user.id && (
                    <Button
                      size="small"
                      type="ghost"
                      onClick={() =>
                        updateInvoiceStatus(InvoiceApprovalType.RECALL_APPROVAL)
                      }
                    >
                      회수하기
                    </Button>
                  )}
                </Space>
              }
            />
          )} */}
        </Col>
      </Row>
      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>청구서</Title>
        </Col>
        <Col>
          {/* <Space> */}
          {moveToEditPage &&
            (((invoice.status === InvoiceStatus.DECLINED ||
              invoice.status === InvoiceStatus.DRAFT) &&
              (invoice.submittedBy.id === user.id ||
                user.roleName === USER_ROLE_NAME.ADMIN)) ||
              (invoice.status === InvoiceStatus.APPROVING &&
                invoice.approver.id === user.id)) && (
              <Button size="small" onClick={moveToEditPage}>
                수정하기
              </Button>
            )}
          {/* </Space> */}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Descriptions
            // title="청구서"
            bordered
            column={2}
            size="small"
            // style={{ marginTop: '10px' }}
            // extra={
            //   <Space>
            //     {moveToEditPage &&
            //       (invoice.status === InvoiceStatus.DECLINED ||
            //         invoice.status === InvoiceStatus.DRAFT) &&
            //       (invoice.submittedBy.id === user.id ||
            //         user.roleName === USER_ROLE_NAME.ADMIN) && (
            //         <Button size="small" onClick={moveToEditPage}>
            //           수정하기
            //         </Button>
            //       )}
            //   </Space>
            // }
          >
            <Descriptions.Item label="공급가액(원)">
              {priceToString(invoice.price - invoice.vat)}
            </Descriptions.Item>
            <Descriptions.Item label="부가세(원)">
              {priceToString(invoice.vat)}
            </Descriptions.Item>
            <Descriptions.Item label="합계금액(원)">
              {priceToString(invoice.price)}
            </Descriptions.Item>
            {invoice.vendor.type === VendorType.WORKER &&
              invoice.vendor.application.general.wageForm !== undefined &&
              invoice.vendor.application.general.wageForm ===
                VendorWorkerWageForm.FREELANCER && (
                <Descriptions.Item
                  label={
                    <Tooltip title="인적용역 사업소득에 대한 원천징수 세율은 3.3%(지방소득세 포함)">
                      <span>
                        원천세 <QuestionCircleOutlined rev={undefined} />
                      </span>
                    </Tooltip>
                  }
                >
                  {priceToString(Math.floor((invoice.price * 0.033) / 10) * 10)}
                </Descriptions.Item>
              )}
            {invoice.vendor.type === VendorType.WORKER &&
              invoice.vendor.application.general.wageForm !== undefined &&
              invoice.vendor.application.general.wageForm ===
                VendorWorkerWageForm.FREELANCER && (
                <Descriptions.Item
                  label={
                    <Tooltip title="합계금액 - 원천세">
                      <span>원천세 제외</span>
                    </Tooltip>
                  }
                >
                  {priceToString(
                    invoice.price -
                      Math.floor((invoice.price * 0.033) / 10) * 10,
                  )}
                </Descriptions.Item>
              )}
            <Descriptions.Item label="공사종류">
              {invoice.gongjong ? invoice.gongjong : ''}
            </Descriptions.Item>
            <Descriptions.Item label="용도">
              {invoice.category}
            </Descriptions.Item>
            <Descriptions.Item label="청구일">
              {invoice.billingDate}
            </Descriptions.Item>
            <Descriptions.Item label="상태">
              {invoiceStatusKorean[invoice.status]}
            </Descriptions.Item>
            <Descriptions.Item label="외상거래">
              {invoice.isCreditTransaction === true ? '예' : '아니오'}
            </Descriptions.Item>
            <Descriptions.Item label="프로젝트">
              {invoice.project ? invoice.project.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="제출자">
              {invoice.submittedBy ? invoice.submittedBy.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="전자결재" span={2}>
              결재선: {invoice.approvalConfig.name ?? ''}
              <br />
              결재자:{' '}
              {invoice.approvalConfig.approvers
                .map((a: any) => a.name)
                .join('->')}
              <br />
              참조자:{' '}
              {invoice.approvalConfig.referers
                .map((a: any) => a.name)
                .join(',')}
            </Descriptions.Item>
            <Descriptions.Item
              label="설명"
              span={2}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {invoice.description}
            </Descriptions.Item>

            <Descriptions.Item label="첨부파일" span={2}>
              {pdfFileList}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      {invoice.payments.length !== 0 && (
        <div style={{ marginTop: '30px' }}>
          <InvoicePaymentListComponent
            payments={invoice.payments}
            openCreateInvoicePaymentModal={onOpenCreateInvoicePaymentModal}
          />
        </div>
      )}
      <Row justify={'space-between'} style={{ marginTop: '30px' }}>
        <Col>
          <Title level={5}>거래처</Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Descriptions
            // title="거래처"
            bordered
            column={2}
            size="small"
            // style={{ marginTop: '40px' }}
          >
            <Descriptions.Item label="거래처명">
              {invoice.vendor.application.general.name}
            </Descriptions.Item>
            {invoice.vendor.type === VendorType.COMPANY ? (
              <>
                <Descriptions.Item label="대표명">
                  {invoice.vendor.application.general.representativeName}
                </Descriptions.Item>
                <Descriptions.Item label="회사주소">
                  {invoice.vendor.application.general.companyAddress}
                </Descriptions.Item>
                <Descriptions.Item label="회사전화번호">
                  {invoice.vendor.application.general.corporatePhoneNumber ===
                  undefined
                    ? null
                    : phoneFormatter(
                        invoice.vendor.application.general.corporatePhoneNumber,
                        1,
                      )}
                </Descriptions.Item>
                <Descriptions.Item label="팩스번호">
                  {invoice.vendor.application.general.companyFaxNumber ===
                  undefined
                    ? null
                    : phoneFormatter(
                        invoice.vendor.application.general.companyFaxNumber,
                        1,
                      )}
                </Descriptions.Item>
                <Descriptions.Item label="사업자등록번호">
                  {invoice.vendor.application.general.corporateNumber ===
                  undefined
                    ? null
                    : corporateNumberFormatter(
                        invoice.vendor.application.general.corporateNumber,
                      )}
                </Descriptions.Item>
                <Descriptions.Item label="담당자 이름">
                  {invoice.vendor.application.contactPoint.name}
                </Descriptions.Item>
                <Descriptions.Item label="담당자 이메일">
                  {invoice.vendor.application.contactPoint.email}
                </Descriptions.Item>
                <Descriptions.Item label="담당자 휴대전화번호">
                  {invoice.vendor.application.contactPoint
                    .personalPhoneNumber === undefined
                    ? null
                    : phoneFormatter(
                        invoice.vendor.application.contactPoint
                          .personalPhoneNumber,
                        1,
                      )}
                </Descriptions.Item>
              </>
            ) : (
              <>
                <Descriptions.Item label="주민등록번호">
                  {maskingRrn(
                    invoice.vendor.application.general.residentNumber,
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="주소">
                  {invoice.vendor.application.general.address}
                </Descriptions.Item>
                <Descriptions.Item label="휴대전화번호">
                  {invoice.vendor.application.general.personalPhoneNumber ===
                  undefined
                    ? null
                    : phoneFormatter(
                        invoice.vendor.application.general.personalPhoneNumber,
                        1,
                      )}
                </Descriptions.Item>
                <Descriptions.Item label="직종">
                  {invoice.vendor.application.general.jigjong === undefined
                    ? null
                    : invoice.vendor.application.general.jigjong.map(
                        (tag: any, index: any) => <Tag key={index}>{tag}</Tag>,
                      )}
                </Descriptions.Item>
                <Descriptions.Item label="급여수준">
                  {invoice.vendor.application.general.jobLevel === undefined
                    ? null
                    : invoice.vendor.application.general.jobLevel === '1'
                    ? '기공'
                    : '조공'}
                </Descriptions.Item>
                <Descriptions.Item label="급여방식">
                  {invoice.vendor.application.general.wageForm === undefined
                    ? null
                    : vendorWorkerWageFormKorean[
                        invoice.vendor.application.general
                          .wageForm as VendorWorkerWageForm
                      ]}
                </Descriptions.Item>
              </>
            )}
            <Descriptions.Item label="은행명">
              {invoice.vendor.application.accountInfo.bankName}
            </Descriptions.Item>
            <Descriptions.Item label="예금주">
              {invoice.vendor.application.accountInfo.accountHolder}
            </Descriptions.Item>
            <Descriptions.Item label="계좌번호">
              {invoice.vendor.application.accountInfo.accountNumber}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>

      {invoice.project === null && (
        <SubInvoiceListComponent
          data={invoice.children}
          openSubInvoiceDetailDrawer={openSubInvoiceDetailDrawer!}
          openSubInvoiceCreateModal={openSubInvoiceCreateModal!}
          excludeSubInvoice={excludeSubInvoice!}
        />
      )}
      <div style={{ marginTop: '30px' }}>
        <InvoiceHistoriesComponent
          invoiceHistories={invoice.invoiceHistories}
          onOpenCreateInvoiceCommentModal={onOpenCreateInvoiceCommentModal}
        />
      </div>
    </StyledDiv>
  );
}
export default InvoiceDetailComponent;
